import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'

const pinia = createPinia()

const transientKeys = {
  game: ['confirmingEndGame'],
  boerenbridge: ['confirmingEndGame']
}

pinia.use(({ store }) => {
  store.$subscribe((_, state) => {
    const exclude = transientKeys[store.$id] || []
    const filtered = { ...state }
    for (const key of exclude) delete filtered[key]
    sessionStorage.setItem(store.$id, JSON.stringify(filtered))
  })
})

createApp(App).use(pinia).mount('#app')
